export const PLATFORM_FEE = 15
export const DESIGN_FEE = 0
